module.exports = __webpack_public_path__ + "img/bg03s.8494d09d.jpg";